(function () {
  'use strict';

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function remaining(endDate) {
    var diff = endDate.getTime() - Date.now();
    if (diff <= 0) {
      return { expired: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    var totalSeconds = Math.floor(diff / 1000);
    return {
      expired: false,
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
  }

  function setValue(root, unit, value) {
    var box = root.querySelector('[data-bc-unit="' + unit + '"] [data-bc-value]');
    if (box) box.textContent = pad(value);
  }

  function hideBar(root) {
    root.hidden = true;
    var section = root.closest('.shopify-section');
    if (section) section.style.display = 'none';
  }

  function initCountdown(root) {
    if (!root || root.dataset.bcInitialized === 'true') return;
    root.dataset.bcInitialized = 'true';

    var endAt = root.dataset.endAt;
    var hideExpired = root.dataset.hideExpired === 'true';
    var expiredText = root.dataset.expiredText || '';
    var endDate = endAt ? new Date(endAt) : null;

    if (!endDate || isNaN(endDate.getTime())) return;

    var message = root.querySelector('.barra-contagem__message:not(.barra-contagem__message--mobile)');
    var messageMobile = root.querySelector('.barra-contagem__message--mobile');
    var timer = root.querySelector('.barra-contagem__timer');
    var intervalId;

    function tick() {
      var time = remaining(endDate);

      setValue(root, 'days', time.days);
      setValue(root, 'hours', time.hours);
      setValue(root, 'minutes', time.minutes);
      setValue(root, 'seconds', time.seconds);

      if (!time.expired) return;

      window.clearInterval(intervalId);

      if (hideExpired) {
        hideBar(root);
        return;
      }

      if (expiredText) {
        if (message) message.textContent = expiredText;
        if (messageMobile) messageMobile.textContent = expiredText;
      }
      if (timer) timer.setAttribute('aria-hidden', 'true');
    }

    tick();
    intervalId = window.setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-barra-contagem]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector('[data-barra-contagem]');
    if (bar) {
      delete bar.dataset.bcInitialized;
      initCountdown(bar);
    }
  });
})();
